import moment from 'moment';
import { CHAT_NOTIFICATION_TYPE } from '@/constants/notifications/constants';

class Notification {
  constructor({ type, title, description }) {
    this.type = type;
    this.title = title;
    this.description = description;
    this.timestamp = moment();
  }
}

const removeNotificationsForInteraction = ({ commit, rootGetters }, interactionId) => {
  const elementsIds = rootGetters['ELEMENTS/getElementIdsByInteractionId'](interactionId);
  elementsIds.forEach(id => commit('removeNotification', id));
};

const elementNotificationActions = {
  chat: {
    addUnreadMessageNotification({ dispatch, getters, rootGetters }, { elementId, title, description }) {
      const element = rootGetters['ELEMENTS/getElement'](elementId);
      if (
        !element ||
        element.isEnded ||
        (rootGetters['WINDOWS/focusedInteractionId'] === element.interactionId &&
          rootGetters['WINDOWS/focusedElementId'] === elementId)
      ) {
        return;
      }
      dispatch('addNotification', { elementId, type: CHAT_NOTIFICATION_TYPE.message.unread, title, description });
    },

    clearUnreadMessagesNotifications({ dispatch }, elementId) {
      dispatch('removeNotificationsByType', { elementId, type: CHAT_NOTIFICATION_TYPE.message.unread });
    },

    clearAllNotificationForElement({ dispatch }, elementId) {
      dispatch('removeNotification', elementId);
    }
  },

  telephony: {},

  email: {},

  system: {
    addSystemNotification({ commit }, payload) {
      commit('addSystemNotification', payload);
    },
    dismissSystemNotification({ commit }, payload) {
      commit('dismissSystemNotification', payload);
    },
    dismissAllSystemNotifications({ commit }) {
      commit('dismissAllSystemNotifications');
    },
    updateSystemNotifications({ commit }, payload) {
      commit('updateSystemNotifications', payload);
    },
    removeWelcomeNotification({ commit }) {
      commit('removeWelcomeNotification');
    },
    updateUnreadNotifications({ commit }, value) {
      commit('updateUnreadNotifications', value);
    }
  },

  callbacks: {
    setCallbacks({ commit }, payload) {
      commit('setCallbacks', payload);
    }
  },

  generic: {
    addNotification({ commit }, { elementId, type, title, description }) {
      commit('addNotification', {
        elementId,
        notification: new Notification({ type, title, description })
      });
    },

    removeNotificationsByType({ commit }, { elementId, type }) {
      commit('removeNotificationsByType', { elementId, type });
    },

    removeNotification({ commit }, elementId) {
      commit('removeNotification', elementId);
    }
  }
};

export default {
  removeNotificationsForInteraction,
  ...elementNotificationActions.chat,
  ...elementNotificationActions.telephony,
  ...elementNotificationActions.email,
  ...elementNotificationActions.generic,
  ...elementNotificationActions.callbacks,
  ...elementNotificationActions.system
};
